import(/* webpackMode: "eager" */ "/app/app/[locale]/(public)/terms-conditions/page.tsx");
